"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargerControlChargingPortStateSerialization = void 0;
class ChargerControlChargingPortStateSerialization {
    static serialize(entity) {
        const copy = { ...entity };
        copy.reset_expires_at = entity.reset_expires_at
            ? entity.reset_expires_at.getTime() * 1000000
            : undefined;
        return JSON.stringify(copy);
    }
    static deserialize(msg) {
        const entity = JSON.parse(msg);
        const copy = { ...entity };
        copy.reset_expires_at = entity.reset_expires_at
            ? new Date(entity.reset_expires_at / 1000000)
            : undefined;
        return copy;
    }
}
exports.ChargerControlChargingPortStateSerialization = ChargerControlChargingPortStateSerialization;
